import { STATUS } from '@app/constants/commonConstants';

export const commonInitialStore = {
  getCommonVarsStatus: STATUS.IDLE,
  isCSPCustomer: false,
  displayToastType: ''
};
